import styled from 'styled-components';

import Button from 'components/UI/Button';

import { breakpoints } from '_constants/mediaOptions';

const CopyButton = ({ children, ...rest }) => (<Button {...rest}>{children}</Button>);

const StyledCopyButton = styled(CopyButton)`
    .copy-button--label {
        &.copied {
            color: var(--black);
        }

        ${breakpoints.md} {
            display: none;
        }
    }
`;

export default StyledCopyButton;
